export enum AuthStep {
  STEP_1,
  STEP_2,
  STEP_3,
  CARD_DETAIL,
  CARD_IS_EXIST,
  CARD_NUMBER,
  CARD_STATUS,
  OAUTH_FAILED,
}
